<template>
  <div>
    <div class="page-title">markdown文档管理</div>
    <el-card v-loading="loading">
      <el-button type="primary" @click="handleAdd">新增文档</el-button>
      <el-table :data="markdownList">
        <el-table-column label="标题" prop="title"></el-table-column>
        <el-table-column label="Key" prop="uniqueKey"></el-table-column>
        <el-table-column label="版本" prop="version" width="100"></el-table-column>
        <el-table-column label="操作人" prop="operator" width="150"></el-table-column>
        <el-table-column label="修改时间" prop="modifyTime" width="200"></el-table-column>
        <el-table-column label="创建时间" prop="insertTime" width="200"></el-table-column>

        <el-table-column label="操作" width="80" v-slot="{ row }">
          <el-button type="text" @click="handleEdit(row)">编辑</el-button>
        </el-table-column>
      </el-table>
    </el-card>
    <el-dialog :visible.sync="showEdit" :title="dialogTitle" fullscreen destroy-on-close>
      <el-form v-if="editRow" ref="formRef" :model="editRow" :rules="rules">
        <el-form-item label="标题" prop="title">
          <el-input v-model="editRow.title" placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="版本" prop="version">
          <el-input v-model="editRow.version" placeholder="请输入版本号"></el-input>
        </el-form-item>
        <el-form-item label="Key" prop="uniqueKey">
          <el-input v-model="editRow.uniqueKey" placeholder="请输入唯一Key，由数字、下划线和字母构成"></el-input>
        </el-form-item>
        <el-form-item style="margin-top: 40px;">
          <cherry-markdown
            ref="markdownEditRef"
            class="markdown-container"
            :markdown-id="`markdown-${editRow.id}`"
            :content="editRow.content"
            :height="900"
          ></cherry-markdown>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSave">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash-es'
import commonService from '@/api/common'
import CherryMarkdown from '@/components/CherryMarkdown'

export default {
  name: 'MarkdownList',
  components: {
    CherryMarkdown
  },
  data() {
    function checkKey(rule, value, callback) {
      if (!value) {
        return callback(new Error('请输入唯一Key'))
      }

      if (!/^[a-zA-Z0-9_]+$/.test(value)) {
        return callback(new Error('唯一Key由数字、下划线和字母构成'))
      }

      callback()
    }

    return {
      loading: false,
      markdownList: [],
      showEdit: false,
      editRow: null,
      rules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' },
        ],
        version: [
          { required: true, message: '请输入版本号', trigger: 'blur' },
        ],
        uniqueKey: [
          { required: true, validator: checkKey, trigger: 'blur' }
        ],
      },
      saving: false,
    }
  },
  computed: {
    dialogTitle() {
      return this.editRow?.id ? `编辑${this.editRow.title}` : '新建Markdown文档'
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.loading = true
      try {
        const { list } = await commonService.findMarkdown()
        this.markdownList = list
      } catch (error) {
        this.$message({
          type: 'error',
          message: '查询文档列表异常.' + error.message,
          duration: 5000
        })
      }
      this.loading = false
    },

    handleAdd() {
      this.editRow = {
        title: '',
        version: '',
        uniqueKey: '',
        content: ''
      }
      this.showEdit = true
    },

    handleEdit(row) {
      this.editRow = cloneDeep(row)
      this.showEdit = true
    },

    handleClose() {
      this.showEdit = false
      this.editRow = null
    },

    async handleSave() {
      try {
        await this.$refs.formRef.validate()
      } catch (error) {
        console.error(error)
        return
      }

      const markdownContent = this.$refs.markdownEditRef.getContent()
      if (!markdownContent) {
        return this.$message({
          type: 'warning',
          message: '请编辑文档内容',
          duration: 5000
        })
      }

      const postData = {
        ...this.editRow,
        operator: undefined,
        modifyTime: undefined,
        insertTime: undefined,
        content: markdownContent
      }

      this.saving = true
      try {
        await commonService.saveMarkdown(postData)
        this.$message({
          type: 'success',
          message: '修改成功',
          duration: 5000
        })
        this.handleClose()
        this.fetchData()
      } catch (error) {
        console.error(error)
        this.$message({
          type: 'error',
          message: '修改失败.' + error.message,
          duration: 5000
        })
      }
    },
  }
}
</script>
